import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type FileStatusSubtitleProps = ComponentPropsWithoutRef<'p'>;

export const FileStatusSubtitle = memo(({ className, ...restOfProps }: FileStatusSubtitleProps) => (
  <p className={cn('text-12 text-grey-10', className)} {...restOfProps} />
));

FileStatusSubtitle.displayName = 'FileStatusSubtitle';
